import React, { useState, useEffect, useRef, useMemo } from "react";
import "../css/checkout.scss";
import { useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { BASE_URL, LIST_URL } from "../constans/ApiEndpointConstants";
import { sendMessage } from "../apis/SendMessageAPI";
import CheckoutHeader from "./common/CheckoutHeader";
import Cookies from "js-cookie";
import * as FacebookAPI from "../apis/FacebookAPI";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as GetPixelAPI from "../apis/GetPixelAPI";

// 给图片加上前缀
const resolveUrl = (raw) => {
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
  return `${LIST_URL.replace(/\/$/, "")}/${String(raw).replace(/^\//, "")}`;
};

// 清理空段落（包括只包含 &nbsp; 的 p 标签）和多余的 <br>
const cleanEmptyParagraphs = (html) => {
  if (!html) return "";

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // 1. 先清理单独的 <br> 标签（在段落开头或结尾的连续 <br>）
  const allElements = tempDiv.querySelectorAll("*");

  allElements.forEach((el) => {
    // 检查元素内是否有连续的 <br> 标签
    const childNodes = Array.from(el.childNodes);

    // 找出连续的 <br> 序列
    let i = 0;
    while (i < childNodes.length) {
      const node = childNodes[i];

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
        // 检查前面是否也是 <br>
        let j = i;
        let brCount = 0;
        while (
          j < childNodes.length &&
          childNodes[j].nodeType === Node.ELEMENT_NODE &&
          childNodes[j].tagName === "BR"
        ) {
          brCount++;
          j++;
        }

        if (brCount > 0) {
          // 删除多余的 <br>，保留一个或全部删除
          // 如果在段落开头或结尾，删除所有
          // 如果在中间，保留一个
          const isAtStart = i === 0;
          const isAtEnd = j >= childNodes.length;

          if (isAtStart || isAtEnd) {
            // 删除所有 <br>
            for (let k = i; k < j; k++) {
              childNodes[k].remove();
            }
          } else {
            // 保留一个 <br>，删除其余的
            for (let k = i + 1; k < j; k++) {
              childNodes[k].remove();
            }
          }
        }
      }

      i++;
    }

    // 2. 清理段落内只有 <br> 和 &nbsp; 的情况
    const textContent = el.textContent.replace(/\u00A0/g, "").trim();
    const hasContent =
      textContent ||
      el.querySelector(
        "img, video, iframe, strong, em, a, span, table, ul, ol, blockquote"
      );

    if (!hasContent && el.tagName === "P") {
      el.remove();
    }
  });

  // 3. 清理顶层连续的 <br>
  const topChildNodes = Array.from(tempDiv.childNodes);
  let topI = 0;
  while (topI < topChildNodes.length) {
    const node = topChildNodes[topI];

    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
      let j = topI;
      let brCount = 0;
      while (
        j < topChildNodes.length &&
        topChildNodes[j].nodeType === Node.ELEMENT_NODE &&
        topChildNodes[j].tagName === "BR"
      ) {
        brCount++;
        j++;
      }

      if (brCount > 0) {
        const isAtStart = topI === 0;
        const isAtEnd = j >= topChildNodes.length;

        if (isAtStart || isAtEnd) {
          for (let k = topI; k < j; k++) {
            topChildNodes[k].remove();
          }
        } else {
          for (let k = topI + 1; k < j; k++) {
            topChildNodes[k].remove();
          }
        }
      }
    }
    topI++;
  }

  // 4. 清理空的段落（只包含 &nbsp; 和 <br>）
  const paragraphs = tempDiv.querySelectorAll("p");
  paragraphs.forEach((p) => {
    const clone = p.cloneNode(true);
    const brs = clone.querySelectorAll("br");
    brs.forEach((br) => br.remove());

    const text = clone.textContent.replace(/\u00A0/g, "").trim();
    const hasContent =
      text ||
      clone.querySelector(
        "img, video, iframe, strong, em, a, span, table, ul, ol, blockquote"
      );

    if (!hasContent) {
      p.remove();
    }
  });

  return tempDiv.innerHTML;
};

const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const campaignDetails = location.state?.detailsData || null;
  const donation_id = campaignDetails?.id;
  const [selectedItems, setSelectedItems] = useState(
    location.state?.selectedItems || []
  );
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [pixelRes, setPixelRes] = useState(null);

  // 初始选中的 index 列表
  const initialSelectedIndexes = useMemo(() => {
    return location.state?.selectedItems?.map((item) => item.index) || [];
  }, [location.state?.selectedItems]);

  // 控制其他回报列表的显示
  const [showOtherReturns, setShowOtherReturns] = useState(
    initialSelectedIndexes.length === 0
  );

  const lastSelectedIndex =
    selectedItems.length > 0 ? selectedItems[0].index : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    setOpenDropdownIndex(null);
  }, [lastSelectedIndex]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const url = BASE_URL;
    const strippedUrl = url.replace(/^https?:\/\//, "");

    GetPixelAPI.getpixel(strippedUrl).then((res) => {
      const pixelApidata = res.data.data;
      setPixelRes(pixelApidata);
    });
  }, []);

  // 处理单个物品的选择
  const handleItemSelect = (item) => {
    const isSelected = selectedItems.some(
      (selected) => selected.index === item.index
    );
    if (isSelected) {
      // 如果已选中，则取消选中
      setSelectedItems(
        selectedItems.filter((selected) => selected.index !== item.index)
      );
    } else {
      // 如果未选中，则添加到选中列表
      setSelectedItems([...selectedItems, { ...item, quantity: 1 }]);

      // 触发 CustomizeProduct 事件
      triggerCustomizeProductEvent(item.price);
    }
  };

  // 给图片加上前缀
  // const resolveUrl = (raw) => {
  //   if (!raw) return "";
  //   if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
  //   return `${LIST_URL.replace(/\/$/, "")}/${String(raw).replace(/^\//, "")}`;
  // };

  // 物品捐赠金额（支持多选，计算所有选中项的总金额）
  const itemDonationAmount = useMemo(
    () =>
      selectedItems.reduce(
        (total, item) => total + Number(item.price || 0) * (item.quantity || 1),
        0
      ),
    [selectedItems]
  );

  // 计算总数量（支持多选，计算所有选中项的总数量）
  const totalSelectedQuantity = useMemo(
    () =>
      selectedItems.reduce(
        (total, item) => total + (Number(item.quantity) || 1),
        0
      ),
    [selectedItems]
  );

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType, auxiliaryProps) => {
    // 根据事件类型使用不同的cookie名
    let cookieName = `fb_event_id_${eventType}`;

    if (eventType === "CustomizeProduct") {
      if (auxiliaryProps) {
        cookieName = `fb_event_id_${eventType}_${auxiliaryProps}`;
      }
    }

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  // 触发 CustomizeProduct 事件
  const triggerCustomizeProductEvent = (amount) => {
    if (!amount || amount <= 0) {
      return;
    }

    // 调用 PixelWithEvent
    PixelWithEvent("CustomizeProduct", event_id);

    // 如果 pixelRes 已加载，触发 Facebook Pixel 事件
    if (pixelRes && pixelRes.pixel && pixelRes.fbqToken) {
      const event_id = getEventId("CustomizeProduct", amount);

      const contentIds = ["donation"];
      const numItems = 1;
      const contents = [
        {
          id: "donation",
          quantity: 1,
          title: "Donation",
        },
      ];

      const eventData = {
        content_ids: contentIds,
        content_name: "Donation",
        content_category: "Donation",
        value: parseFloat(amount),
        currency: "jpy",
        num_items: numItems,
        contents: contents,
      };

      // 构建 userdata（可能不完整，但尽量使用已有信息）
      let userdata = {
        em: "",
        ph: "",
        fn: "",
        ln: "",
        ct: "",
        st: "",
        zp: "",
        country: "JPY",
        external_id: "",
        client_ip_address: "",
        client_user_agent: "",
        fbc: "",
        fbp: "",
        lead_id: "",
        anon_id: "",
        madid: "",
        page_id: "",
        page_scoped_user_id: "",
        ctwa_clid: "",
        ig_account_id: "",
        ig_sid: "",
      };

      // 触发 Facebook Pixel 事件
      FacebookAPI.Facebook(
        campaignDetails?.fbq_token,
        campaignDetails.pixel,
        event_id,
        "CustomizeProduct",
        eventData,
        userdata
      );
    }
  };

  let event_id = getEventId("payment");

  const checkoutPageMessageSentRef = useRef(false);

  useEffect(() => {
    if (!checkoutPageMessageSentRef.current) {
      sendMessage(
        `${BASE_URL} [Checkout Page]:id=${donation_id}:userid=${userid}`
      );

      checkoutPageMessageSentRef.current = true;
    }
  }, [donation_id, userid]);

  // 清理空段落（包括只包含 &nbsp; 的 p 标签）和多余的 <br>
  // const cleanEmptyParagraphs = (html) => {
  //   if (!html) return "";

  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = html;

  //   // 1. 先清理单独的 <br> 标签（在段落开头或结尾的连续 <br>）
  //   const allElements = tempDiv.querySelectorAll("*");

  //   allElements.forEach((el) => {
  //     // 检查元素内是否有连续的 <br> 标签
  //     const childNodes = Array.from(el.childNodes);

  //     // 找出连续的 <br> 序列
  //     let i = 0;
  //     while (i < childNodes.length) {
  //       const node = childNodes[i];

  //       if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
  //         // 检查前面是否也是 <br>
  //         let j = i;
  //         let brCount = 0;
  //         while (
  //           j < childNodes.length &&
  //           childNodes[j].nodeType === Node.ELEMENT_NODE &&
  //           childNodes[j].tagName === "BR"
  //         ) {
  //           brCount++;
  //           j++;
  //         }

  //         if (brCount > 0) {
  //           // 删除多余的 <br>，保留一个或全部删除
  //           // 如果在段落开头或结尾，删除所有
  //           // 如果在中间，保留一个
  //           const isAtStart = i === 0;
  //           const isAtEnd = j >= childNodes.length;

  //           if (isAtStart || isAtEnd) {
  //             // 删除所有 <br>
  //             for (let k = i; k < j; k++) {
  //               childNodes[k].remove();
  //             }
  //           } else {
  //             // 保留一个 <br>，删除其余的
  //             for (let k = i + 1; k < j; k++) {
  //               childNodes[k].remove();
  //             }
  //           }
  //         }
  //       }

  //       i++;
  //     }

  //     // 2. 清理段落内只有 <br> 和 &nbsp; 的情况
  //     const textContent = el.textContent.replace(/\u00A0/g, "").trim();
  //     const hasContent =
  //       textContent ||
  //       el.querySelector(
  //         "img, video, iframe, strong, em, a, span, table, ul, ol, blockquote"
  //       );

  //     if (!hasContent && el.tagName === "P") {
  //       el.remove();
  //     }
  //   });

  //   // 3. 清理顶层连续的 <br>
  //   const topChildNodes = Array.from(tempDiv.childNodes);
  //   let topI = 0;
  //   while (topI < topChildNodes.length) {
  //     const node = topChildNodes[topI];

  //     if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
  //       let j = topI;
  //       let brCount = 0;
  //       while (
  //         j < topChildNodes.length &&
  //         topChildNodes[j].nodeType === Node.ELEMENT_NODE &&
  //         topChildNodes[j].tagName === "BR"
  //       ) {
  //         brCount++;
  //         j++;
  //       }

  //       if (brCount > 0) {
  //         const isAtStart = topI === 0;
  //         const isAtEnd = j >= topChildNodes.length;

  //         if (isAtStart || isAtEnd) {
  //           for (let k = topI; k < j; k++) {
  //             topChildNodes[k].remove();
  //           }
  //         } else {
  //           for (let k = topI + 1; k < j; k++) {
  //             topChildNodes[k].remove();
  //           }
  //         }
  //       }
  //     }
  //     topI++;
  //   }

  //   // 4. 清理空的段落（只包含 &nbsp; 和 <br>）
  //   const paragraphs = tempDiv.querySelectorAll("p");
  //   paragraphs.forEach((p) => {
  //     const clone = p.cloneNode(true);
  //     const brs = clone.querySelectorAll("br");
  //     brs.forEach((br) => br.remove());

  //     const text = clone.textContent.replace(/\u00A0/g, "").trim();
  //     if (!text) {
  //       p.remove();
  //     }
  //   });

  //   return tempDiv.innerHTML;
  // };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const ReturnCard = ({
    item,
    index,
    isSelected,
    selectedQuantity,
    onSelect,
    onQuantityChange,
    openDropdownIndex,
    setOpenDropdownIndex,
    isInitiallyExpanded,
  }) => {
    const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);
    const dropdownRef = useRef(null);

    // Auto-expand if selected
    useEffect(() => {
      if (isSelected && !isExpanded) {
        setIsExpanded(true);
      }
    }, [isSelected]);

    // Handle click outside for dropdown
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          openDropdownIndex === index &&
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setOpenDropdownIndex(null);
        }
      };

      if (openDropdownIndex === index) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [openDropdownIndex, index, setOpenDropdownIndex]);

    const toggleExpand = (e) => {
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    };

    return (
      <div className={`return-selection-card ${isSelected ? "selected" : ""}`}>
        <div
          className="card-header"
          onClick={toggleExpand}
          style={{ cursor: "pointer" }}
        >
          <div className="card-header-content">
            <div className="price-container">
              <span className="price">
                {Number(item.price).toLocaleString("en", {
                  maximumFractionDigits: 0,
                })}
                <span className="currency">円</span>
              </span>
            </div>
            <div
              className="checkbox"
              onClick={(e) => {
                e.stopPropagation();
                onSelect();
              }}
            >
              {isSelected && (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 7L5.5 10L11.5 4"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          </div>
        </div>

        {isExpanded && (
          <div className="card-body">
            {item.img && (
              <div className="card-image">
                <img src={resolveUrl(item.img)} alt="" />
              </div>
            )}
            <div className="card-details">
              <div
                className="card-text"
                dangerouslySetInnerHTML={{
                  __html: cleanEmptyParagraphs(item.text),
                }}
              />
            </div>

            {isSelected && (
              <div className="card-footer-action">
                <span className="quantity-label">数量</span>
                <div
                  className={`custom-quantity-dropdown ${
                    openDropdownIndex === index ? "open" : ""
                  }`}
                  ref={dropdownRef}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdownIndex(
                      openDropdownIndex === index ? null : index
                    );
                  }}
                >
                  <div className="dropdown-trigger">
                    <span className="current-value">
                      {selectedQuantity || 1}
                    </span>
                    <div className="dropdown-arrow">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </div>
                  </div>
                  {openDropdownIndex === index && (
                    <div className="dropdown-menu">
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <div
                          key={num}
                          className={`dropdown-item ${
                            selectedQuantity === num ? "selected" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            onQuantityChange(num);
                            setOpenDropdownIndex(null);
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleQuantityChange = (index, num) => {
    setSelectedItems(
      selectedItems.map((selected) =>
        selected.index === index ? { ...selected, quantity: num } : selected
      )
    );
  };

  // 分离初始选中项和其他项
  const { initialItems, otherItems } = useMemo(() => {
    const initial = [];
    const other = [];
    campaignDetails?.donateList?.forEach((item, index) => {
      if (initialSelectedIndexes.includes(index)) {
        initial.push({ ...item, originalIndex: index });
      } else {
        other.push({ ...item, originalIndex: index });
      }
    });
    return { initialItems: initial, otherItems: other };
  }, [campaignDetails, initialSelectedIndexes]);

  const renderReturnCard = (item, index) => {
    const selectedItem = selectedItems.find((s) => s.index === index);
    const isSelected = !!selectedItem;
    const selectedQuantity = selectedItem ? selectedItem.quantity : 1;

    return (
      <ReturnCard
        key={index}
        item={item}
        index={index}
        isSelected={isSelected}
        selectedQuantity={selectedQuantity}
        onSelect={() => handleItemSelect({ ...item, index })}
        onQuantityChange={(num) => handleQuantityChange(index, num)}
        openDropdownIndex={openDropdownIndex}
        setOpenDropdownIndex={setOpenDropdownIndex}
        isInitiallyExpanded={false}
      />
    );
  };

  return (
    <div className="checkout-page-container">
      <CheckoutHeader />

      <div className="checkout-steps">
        <div className="step active">
          <div className="step-circle">1</div>
          <div className="step-label">リターン選択</div>
        </div>
        <div className="step-line"></div>
        <div className="step">
          <div className="step-circle">2</div>
          <div className="step-label">入力</div>
        </div>
        <div className="step-line"></div>
        <div className="step">
          <div className="step-circle">3</div>
          <div className="step-label">支援完了</div>
        </div>
      </div>

      <div className="checkout-content-wrapper">
        <div className="checkout-main">
          <div className="back-link">&lt; 概要に戻る</div>
          <h2 className="section-title">
            {initialSelectedIndexes.length > 0
              ? "選択中のリターン"
              : "支援するリターンを選択してください"}
            <svg
              fill="#383d43"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                display: initialSelectedIndexes.length > 0 ? "none" : "block",
              }}
            >
              <path
                clipRule="evenodd"
                d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fillRule="evenodd"
              ></path>
              <path d="M9.18457 10.1104H10.7725C10.8076 9.44824 11.2529 9.02051 11.9268 9.02051C12.5947 9.02051 13.04 9.4248 13.04 9.98145C13.04 10.5381 12.8115 10.8252 12.0557 11.2764C11.2471 11.751 10.9248 12.2783 11.001 13.1982L11.0127 13.5381H12.5654V13.2275C12.5654 12.6533 12.7822 12.3662 13.5615 11.915C14.3877 11.4287 14.8154 10.8135 14.8154 9.92871C14.8154 8.59277 13.708 7.66113 12.0322 7.66113C10.2334 7.66113 9.21387 8.66895 9.18457 10.1104ZM11.8096 16.3389C12.3428 16.3389 12.7705 15.9346 12.7705 15.4189C12.7705 14.9033 12.3428 14.499 11.8096 14.499C11.2822 14.499 10.8545 14.9033 10.8545 15.4189C10.8545 15.9346 11.2822 16.3389 11.8096 16.3389Z"></path>
            </svg>
          </h2>
          <p className="fee-notice">
            ※ 表示金額にはシステム利用料が含まれています
          </p>

          <div className="return-selection-list">
            {/* 渲染初始选中项 */}
            {initialItems.map((item) =>
              renderReturnCard(item, item.originalIndex)
            )}

            {/* 如果有初始选中项且有其他项，显示折叠按钮 */}
            {initialItems.length > 0 && otherItems.length > 0 && (
              <div
                className="toggle-other-returns"
                onClick={() => setShowOtherReturns(!showOtherReturns)}
              >
                他のリターンも選択する
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transform: showOtherReturns
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                >
                  <path
                    d="M2 4L6 8L10 4"
                    stroke="#1E88E5"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}

            {/* 渲染其他项 */}
            {showOtherReturns && (
              <div className="other-returns-container">
                {otherItems.map((item) =>
                  renderReturnCard(item, item.originalIndex)
                )}
              </div>
            )}
          </div>

          <div className="system-fee-notice">
            <div className="notice-header">
              <span className="info-icon">
                <svg
                  fill="#2ea3e4"
                  height={20}
                  viewBox="0 0 40 40"
                  width={20}
                  xmlns="http://www.w3.org/2000/svg"
                  className="css-rt7yb9"
                >
                  <path
                    clipRule="evenodd"
                    d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                    fillRule="evenodd"
                  />
                  <circle cx={20} cy={12} r={2} />
                  <rect height={14} rx={2} width={4} x={18} y={16} />
                </svg>
              </span>
              システム利用料について
            </div>
            <p>
              システム利用料は、1回のお支払いごとに220円（税込）頂戴いたします。複数のリターンを支援する場合もお支払いごとに220円（税込）となります。
            </p>
          </div>

          <div className="summary-section">
            <div className="summary-row">
              <span>支援金額</span>
              <span>
                {itemDonationAmount.toLocaleString("en", {
                  maximumFractionDigits: 0,
                })}
                円
              </span>
            </div>
            <div className="summary-row">
              <span>システム利用料</span>
              <span>220円</span>
            </div>
            <div className="summary-row total">
              <span>合計金額</span>
              <span className="amount-text">
                {(itemDonationAmount + 220).toLocaleString("en", {
                  maximumFractionDigits: 0,
                })}
                円
              </span>
            </div>
          </div>

          <div className="bottom-action">
            <button
              className="next-btn-large"
              disabled={itemDonationAmount === 0}
              onClick={() => {
                // 将 selectedItems 存入本地缓存
                localStorage.setItem(
                  "checkoutSelectedItems",
                  JSON.stringify(selectedItems)
                );
                localStorage.setItem(
                  "checkoutTotalAmount",
                  itemDonationAmount.toString()
                );
                localStorage.setItem(
                  "checkoutTotalQuantity",
                  totalSelectedQuantity.toString()
                );

                navigate("/payment", {
                  state: {
                    campaignDetails,
                    selectedItems,
                    totalAmount: itemDonationAmount,
                    totalQuantity: totalSelectedQuantity,
                  },
                });
                toTop();
              }}
            >
              次に進む
            </button>
          </div>
        </div>

        <div className="checkout-sidebar">
          <div className="campaign-summary-card">
            <div className="campaign-image">
              <img src={resolveUrl(campaignDetails?.image?.[0]?.url)} alt="" />
            </div>
            <h3 className="campaign-title">{campaignDetails?.title}</h3>
            <div className="organizer">
              <img
                src={
                  resolveUrl(campaignDetails?.avatar) || "/main-jp/person.jpg"
                }
                alt=""
                className="organizer-avatar"
              />
              <span>{campaignDetails?.name || "主催者"}</span>
            </div>
          </div>

          <div className="next-btn-container">
            <button
              className="next-btn"
              disabled={itemDonationAmount === 0}
              onClick={() => {
                // 将 selectedItems 存入本地缓存
                localStorage.setItem(
                  "checkoutSelectedItems",
                  JSON.stringify(selectedItems)
                );
                localStorage.setItem(
                  "checkoutTotalAmount",
                  itemDonationAmount.toString()
                );
                localStorage.setItem(
                  "checkoutTotalQuantity",
                  totalSelectedQuantity.toString()
                );

                navigate("/payment", {
                  state: {
                    campaignDetails,
                    selectedItems,
                    totalAmount: itemDonationAmount,
                    totalQuantity: totalSelectedQuantity,
                  },
                });
                toTop();
              }}
            >
              次に進む
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
